<template>
  <div style="padding: 20px;">
    <h3>客户信息</h3>
    <br>
    <a-form :form="form" labelAlign="left" >
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="客户姓名">
            <a-input
              placeholder="请输入"
              :maxLength="50"
              v-decorator="['customerName',{rules: [{ required: true, message: '请输入客户姓名' }]}]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="电话">
            <a-input
              placeholder="请输入"
              v-decorator="['customerPhone',{
                rules:[{pattern: /^1[34578]\d{9}$/, message: '请输入正确的手机号'}],
                validateTrigger: 'blur'
              }]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="省市区/县">
            <a-cascader 
              :options="options" 
              change-on-select 
              placeholder="请选择"
              v-decorator="['region']"
              :fieldNames="{ label: 'label', value: 'label', children: 'children' }"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="详细地址">
            <a-input placeholder="请输入" :maxLength="50" v-decorator="['address']"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="动物类型">
            <a-radio-group
              v-decorator="['animalType',{rules:[{required: true, message: '请选择动物类型'}]}]"
              @change="animalTypeChange"
            >
              <a-radio v-for="el in animalTypeList" :key="el.id" :value="el.name">{{ el.name }}</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :label="`养殖规模（${getUnit(form.getFieldValue('animalType'))}羽）`">
            <a-input-number
              placeholder="请输入"
              v-decorator="['farmScale',{rules: [{ required: true, message: '请输入养殖规模' }]}]"
              :min="1"
              :max="10000"
              :precision="2"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="饲养模式"> 
            <a-radio-group v-decorator="['feedMode',{rules:[{required: true, message: '请选择饲养模式'}]}]">
              <a-radio v-for="el in feedModeList" :key="el.id" :value="el.name">{{ el.name }}</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="业务员">
            <a-input
              placeholder="请输入"
              :maxLength="50"
              v-decorator="['salesManName',{rules: [{ required: true, message: '请输入业务员' }]}]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="所属工厂">
            <a-select 
              placeholder="请选择"
              @change="handleFactoryChange"
              v-decorator="['factoryName',{
                rules:[{required: true, message: '请选择所属工厂'}],
                initialValue:selectFactory
              }]"
            >
              <a-select-option v-for="el in factoryList" :key="el.factoryId" :value="el.factoryName">
                {{ el.factoryName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="聚落/片区">{{settlementName}}</a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import {cityData} from '../../Common/region'
import { animalTypeList} from './Lists'
export default {
  props:['customerInfo'],
  data(){
    return{
      form: this.$form.createForm(this, { name: 'customer' }),
      options:cityData,
      animalTypeList,
      feedPhaseList:[],
      feedModeList:[],
      factoryList:[],
      settlementName:'',
      selectFactory:undefined
    }
  },
  watch:{
    customerInfo(){
      this.form.setFieldsValue(this.customerInfo)
      this.factoryGet()
      let {feedModeList} = this.animalTypeList.find(
        item => item.name == this.customerInfo.animalType
      )
      this.feedModeList = feedModeList
    },
  },
  mounted(){
    this.form.setFieldsValue(this.customerInfo)
    if(this.form.getFieldValue('animalType')){
      let {feedModeList} = this.animalTypeList.find(
        item => item.name == this.form.getFieldValue('animalType')
      )
      this.feedModeList = feedModeList
    }
    this.factoryGet()
  },
  
  methods:{
    getUnit(animalType){
      if(animalType) return animalType == '蛋鸡' ? '万' : '千'
      else return '-'
    },
    handleFactoryChange(value) {
      let factoryAnimalList = this.factoryList.find(item => item.factoryName == value)?.factoryAnimalList;
      let factoryId = this.factoryList.find(item => item.factoryName == value)?.factoryId;
      this.selectFactory = value
      this.settlementName = this.factoryList.find(item => item.factoryName == value)?.settlementName;
      let settlementId = this.factoryList.find(item => item.factoryName == value)?.settlementId;
      this.$emit('setFactory',  {selectFactory:this.selectFactory,settlementId,settlementName:this.settlementName,factoryId})
      if(!factoryAnimalList?.find(item => item.animalName =='2 禽')) {
        this.$warning({
          title: `暂无工厂“${value}”的禽线路填报权限`,
          content: '请确认工厂或负责线路是否有误',
        });
      }
    },
    async factoryGet() {
      let userId = window.localStorage.getItem('staffId')
      const res = await this.$http.get("/sat-collect/auth/permissions", { params:{userId} })
      let { success, data } = res;
      if (success) {
        let { factoryAndSettles} = data;
        this.factoryList = factoryAndSettles || [];
        if(!this.$route.query.copyId && !this.customerInfo.factoryName) this.handleFactoryChange(window.localStorage.getItem('factoryName'))
        else if(this.customerInfo.factoryName) this.handleFactoryChange(this.customerInfo.factoryName)
      }
    },
    animalTypeChange(e){
      this.form.setFieldsValue({feedMode:undefined})
      if(e.target.value){
        let {feedModeList} =this.animalTypeList.find(item => item.name == e.target.value)
        this.feedModeList = feedModeList
      }
      else this.feedModeList = []
    }
  }
}
</script>

<style>

</style>